import { ApiRoutes, QueryError } from '../../../common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '../../../common/services';
import { DomainAutoRegluingsFormFields, DomainRegluingsFormFields } from '../domains.interfaces';
import { DomainRegluing } from '../entities/DomainRegluing.entity';
import { DomainRegluingsQueryKeys } from './domains.keys';

export const useGetAllDomainRegluingsQuery = (siteId: string, domainId: string) =>
  buildQuery<DomainRegluing[], QueryError>([DomainRegluingsQueryKeys.GetAllRegluings, siteId, domainId], async () => {
    const { data } = await apiExecutor.get<DomainRegluing[]>(
      ApiRoutes.SiteDomainsByIdRegluings.replace(':siteId', siteId).replace(':domainId', domainId)
    );
    return data;
  });

export const useCreateDomainRegluingsMutation = (siteId: string, domainId: string) =>
  buildMutation<DomainRegluing, QueryError, DomainRegluingsFormFields>(
    [DomainRegluingsQueryKeys.CreateRegluing, siteId, domainId],
    async (postData) => {
      const { data } = await apiExecutor.post<DomainRegluing>(
        ApiRoutes.SiteDomainsByIdRegluings.replace(':siteId', siteId).replace(':domainId', domainId),
        {
          ...postData
        }
      );
      return data;
    }
  );

export const useDeleteDomainRegluingsMutation = (siteId: string, domainId: string) =>
  buildMutation<void, QueryError, string>(
    [DomainRegluingsQueryKeys.DeleteRegluingById, siteId, domainId],
    async (regluingId) => {
      await apiExecutor.delete<void>(
        ApiRoutes.SiteDomainsByIdRegluingsById.replace(':siteId', siteId)
          .replace(':domainId', domainId)
          .replace(':regluingId', regluingId)
      );
    }
  );

export const useToggleDomainAutoRegluingMutation = (siteId: string) =>
  buildMutation<void, QueryError, DomainAutoRegluingsFormFields>(
    [DomainRegluingsQueryKeys.ToggleAutoRegluings, siteId],
    async (postData) => {
      await apiExecutor.post<DomainRegluing>(ApiRoutes.SiteDomainsAutoRegluings.replace(':siteId', siteId), {
        ...postData
      });
    }
  );
